"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateProportion = exports.getSpinnerSize = exports.convertSizeToRem = exports.getQrImageSrc = exports.getQrSize = void 0;

var _constants = require("./constants");

var getQrSize = function getQrSize(sizePx) {
  if (sizePx < _constants.QR_MIN_SIZE) {
    return _constants.QR_MIN_SIZE;
  }

  if (sizePx > _constants.QR_MAX_SIZE) {
    return _constants.QR_MAX_SIZE;
  }

  return sizePx;
};

exports.getQrSize = getQrSize;

var getQrImageSrc = function getQrImageSrc(data) {
  var sizePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.QR_MIN_SIZE;

  if (!data) {
    return null;
  }

  var qrSize = getQrSize(sizePx);
  return "https://chart.googleapis.com/chart?chs=".concat(qrSize, "x").concat(qrSize, "&choe=UTF-8&chld=M|0&cht=qr&chl=").concat(data);
};

exports.getQrImageSrc = getQrImageSrc;

var convertSizeToRem = function convertSizeToRem() {
  var sizePx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.QR_MIN_SIZE;
  return getQrSize(sizePx) / _constants.PX_TO_REM || null;
};

exports.convertSizeToRem = convertSizeToRem;

var getSpinnerSize = function getSpinnerSize(sizePx) {
  var maxSize = parseInt(_constants.SPINNER_DEFAULT_SIZE, 10);
  var convertedSize = convertSizeToRem(sizePx);
  return convertedSize > maxSize ? _constants.SPINNER_DEFAULT_SIZE : "".concat(convertedSize, "rem");
};

exports.getSpinnerSize = getSpinnerSize;

var calculateProportion = function calculateProportion(size, factor) {
  return convertSizeToRem(size) / factor;
};

exports.calculateProportion = calculateProportion;